import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import InboxMessageItem from '../../components/InboxMessageItem';
import InboxMessageItem2 from '../../components/InboxMessageItem2';
import { useAxios } from '../../utils/hook/useAxios';

import '../../styles/styles.css';
// MessageBox component
function ReservationPage() {
  const [conversations, setConversations] = useState([]);
  const [Message, setMessage] = useState('');
  const [ReservationData, setReservationData] = useState(null);

  const axios = useAxios();
  const { reservationId } = useParams();
  useEffect(() => {
    let fetchReviews = async () => {
      try {
        const response = await axios.get('/conversations/' + reservationId);
        if (response.data) {
          setConversations(response.data);
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };
    fetchReviews();
  }, []);

  useEffect(() => {
    let fetchReviews = async () => {
      try {
        const response = await axios.get('/conversations/' + reservationId);
        if (response.data) {
          setConversations(response.data);
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };

    const intervalId = setInterval(() => {
      fetchReviews();
    }, 2000); // 2000 millisecondes = 2 secondes

    // Nettoyez l'intervalle lors du démontage du composant
    return () => clearInterval(intervalId);
  }, []);

  function handleSendMessage() {
    axios
      .post('/conversations', {
        authorDriverRole: 0,
        driversId: conversations[0].driversId,
        sentTime: new Date(),
        reservationId: conversations[0].reservationId,
        message: Message,
      })

      .then((response) => {
        (() => {
          axios
            .get('/conversations/' + conversations[0].reservationId)

            .then((response) => setConversations(response.data))

            .catch((error) => console.log(error));
        })();
      })

      .catch((error) => console.log(error));
  }

  function handleAnnulerReservation() {
    axios
      .post('/conversations', {
        authorDriverRole: 0,
        driversId: conversations[0].driversId,
        sentTime: new Date(),
        reservationId: conversations[0].reservationId,
        message: 'Le hote a annulé la reservation',
      })

      .then((response) => {
        (() => {
          axios
            .get('/conversations/' + conversations[0].reservationId)

            .then((response) => setConversations(response.data))

            .catch((error) => console.log(error));
        })();

        (() => {
          axios
            .put('/reservations/' + conversations[0].reservationId, {
              status: '2',
            })

            .then((response) => setReservationData(response.data))

            .catch((error) => console.log(error));
        })();
      })

      .catch((error) => console.log(error));
  }

  return (
    <section className="mb-3">
      <div className="container">
        <section>
          <div className="container py-5">
            <div className="">
              <hr />

              <h3 className="mb-1">Messages</h3>

              <hr />
              <div className="chat-page">
                <div className="msg-inbox">
                  <div className="chats">
                    <div className="msg-page">
                      {conversations &&
                        conversations.map((conv) => (
                          <>
                            {conv.authorDriverRole == '1' ? (
                              <InboxMessageItem data={conv}></InboxMessageItem>
                            ) : (
                              <InboxMessageItem2 data={conv}></InboxMessageItem2>
                            )}
                          </>
                        ))}
                    </div>
                  </div>
                  <div className="msg-bottom">
                    <div className="input-group">
                      <input
                        className="form-control"
                        placeholder="Taper un message..."
                        value={Message}
                        onChange={(e) => setMessage(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            handleSendMessage();
                          }
                        }}
                      ></input>

                      <>
                        <span className="input-group-text send-icon">
                          <i className="bi bi-send" onClick={handleSendMessage}></i>
                        </span>
                      </>
                    </div>
                  </div>
                </div>
                <button
                  type="button"
                  className="col btn btn-danger mt-2 col-md-4 btn-rounded float-end mx-auto me-2"
                  onClick={handleAnnulerReservation}
                >
                  Annuler la reservation
                </button>
                {ReservationData?.status === '2' && (
                  <div class="alert alert-danger col-md-6 mt-2" role="alert">
                    <i class="bi bi-chat-right-dots-fill h5"></i> Cette reservation a été annulé
                    Lorem ipsum dolor, sit amet consectetur adipisicing elit. Cumque, praesentium
                    vero autem iste architecto error temporibus neque, soluta inventore vitae
                    nostrum ducimus animi sint cupiditate aperiam minus, unde dolore est.
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
  );
}

export default ReservationPage;
